module.exports = __webpack_public_path__ + "static/safari-pinned-tab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/examples/shared/favicon/safari-pinned-tab.svg
// module id = 514
// module chunks = 0